import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import DestinationsMapFixed from '../../components/BrandHomePage/DestinationsMap/DestinationsMapFixed';
import AccommodationsList from '../../components/AccommodationsList/AccommodationsList';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { images } from '../../components/shared/assets';
import '../../styles/property-pages.css';

const AccommodationsSantaCatarina: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();

  useEffect(() => {
    initializeAllFeatures();
    setHoveredDestination(null);
  }, [setHoveredDestination]);

  const accommodations = [
    {
      id: 'villa-ponta-dos-ganchos',
      title: 'Villa Ponta dos Ganchos',
      description: 'Our largest villa, with 310 square meters. Enjoy a fully equipped living space with a sauna facing the ocean, a spa bathroom, whirlpool, and private fitness center.',
      images: [images.villas13, images.masterVilla, images.villaExterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'villa-costa-esmeralda',
      title: 'Villa Costa Esmeralda',
      description: 'A villa spanning 230 square meters. Equipped with a dry sauna, ocean-view whirlpool, spa bathroom, fireplace, private heated pool, and comfortable outdoor seating.',
      images: [images.masterVilla, images.villas13, images.villaInterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'villa-tingua',
      title: 'Villa Tinguá',
      description: 'A modern space that features a double bathroom, a dry sauna, and a unique whirlpool set beneath a glass ceiling, bathing the space in natural light.',
      images: [images.villaInterior, images.villaExterior, images.villas13],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'villa-arvoredo',
      title: 'Villa Arvoredo',
      description: 'Its layout includes a unified bedroom and living room and living area. The bedroom provides a cozy retreat with a spacious bathroom.',
      images: [images.villaExterior, images.masterVilla, images.villaInterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'villa-sissial',
      title: 'Villa Sissial',
      description: 'This villa features a separate bedroom and living room, a private deck with a heated pool, solarium, and dry sauna.',
      images: [images.villas13, images.villaInterior, images.villaExterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'villa-anhatomirim',
      title: 'Villa Anhatomirim',
      description: 'A two-story villa that combines a generous living room and a bedroom with a king-size bed.',
      images: [images.masterVilla, images.villaExterior, images.villas13],
      ctaLink: '/contact',
      detailsLink: '/contact'
    }
  ];

  const communalAreas = [
    {
      title: "Our restaurants",
      description: "Enjoy meals where fresh ingredients and fresh takes. Dine at one of our acclaimed restaurants — Beach, Bateiras and Veleza — where ingredients are often sourced directly from our garden."
    },
    {
      title: "Awasi Santa Catarina Spa by Sisley Paris",
      description: "Experience therapeutic massages and skin treatments designed to re-energize and relax, adhering to the renowned protocols of Sisley Paris. Each treatment incorporates natural ingredients for effective and comforting care."
    },
    {
      title: "Tennis and beach tennis",
      description: "Enjoy tennis and beach tennis courts for active recreation with beautiful ocean views."
    }
  ];

  return (
    <div className="property-page">
      {/* Navigation */}
      <UnifiedNavigation variant="light" destination="santa-catarina" />
      
      {/* Accommodations List Component */}
      <AccommodationsList
        variant="santa-catarina"
        heroTitle="Our villas"
        heroImage={images.santaCatarinaHero || images.video1}
        subheaderText="Discover the ideal escape in our villas, consistently ranked among the best accommodations in Brazil. Each unit offers a mix of modern amenities and natural surroundings, ideal for those seeking a peaceful getaway."
        accommodations={accommodations}
        communalAreas={communalAreas}
        communalAreasImage={images.restaurantFeature}
        fullLandscapeImage={images.producingNaturePage.fullDesertLandscape}
      />

      {/* Map Section */}
      <section className="santa-catarina-map-wrapper" style={{ background: 'var(--color-off-white)', padding: '80px 0' }}>
        <DestinationsMapFixed />
      </section>

      {/* Instagram Section */}
      <InstagramSection 
        title="Follow us on Instagram @awasiexperience"
        posts={[
          { src: images.film13, alt: "Instagram 1" },
          { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
          { src: images.film14, alt: "Instagram 3" },
          { src: images.film15, alt: "Instagram 4" }
        ]}
      />

      {/* Footer */}
      <Footer variant="santa-catarina" />
    </div>
  );
};

export default AccommodationsSantaCatarina;